import { render, staticRenderFns } from "./zh_bbj.vue?vue&type=template&id=9fd5b870&scoped=true&"
import script from "./zh_bbj.vue?vue&type=script&lang=js&"
export * from "./zh_bbj.vue?vue&type=script&lang=js&"
import style0 from "./zh_bbj.vue?vue&type=style&index=0&id=9fd5b870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd5b870",
  null
  
)

export default component.exports